import { useEffect } from 'react';
import LeftSidePopupLayout from './modal-layout';
import XCloseIcon from '../icons/x-close';
import Style from './style.module.css'
import { useApiCall } from '../custom-hooks/api-call';
import { useFormik } from 'formik';
import * as yup from "yup";
import moment from 'moment';

const VanDamageModal = ({ onSubmit = () => { }, onClose = () => { }, onError = () => { }, damageData, cars = [] }) => {
  const apiCall = useApiCall();

  useEffect(() => {  
    console.log("damageData", damageData)
    if (damageData?.damage_id) {
      formik.setFieldValue("van", damageData?.van_id || "")
      formik.setFieldValue("incident_date", moment(damageData?.incident_date, "DD-MMMM-YYYY ").format("YYYY-MM-DD") || "")
      formik.setFieldValue("incidentType", damageData?.incident_type || "")
      formik.setFieldValue("location", damageData?.incident_location || "")
      formik.setFieldValue("description", damageData?.description || "")
    }
  }, [damageData])

  const validationSchema = yup.object({
    van : yup
      .string('This Field is Required')
      .required('This Field is Required'),
    incident_date: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    incidentType: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    location: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    description: yup
        .string('This Field is Required')
        .required('This Field is Required'),

  });

  const formik = useFormik({
    initialValues: {
      van:'',
      incident_date: '',
      incidentType: '',
      location: '',
      description: ''
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {

      let extraData = {};

      if (damageData?.damage_id) {
        extraData = {
          "id": damageData?.damage_id
        }
      }

      let data = {
        ...extraData,
        "van_id": values?.van,
        "incident_date": values?.incident_date,
        "incident_type": values?.incidentType,  // 'Accident', 'Damage', 'Theft'
        "incident_location": values?.location,
        "description": values?.description
      }

      try {
        let apiRes = await apiCall({ method: "post", url: "add-update-van-damage-record", data: data })
        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
      } catch (error) {
        console.log("Error", error)
        onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
      }
    },
  });


  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout popupStatus={true} className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}>
        <div className={`${Style["modal_header"]} ${Style.addMeModal_head}`}>
          <h4>{(damageData?.damage_id) ? "Update" : "Add"} Van Damage Record</h4>
          <div onClick={onClose} className={`${Style["close_btn"]} cursor-pointer`}><XCloseIcon /></div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>

                <div className={Style["dcmb__cardBody_formArea_feild"]}>
                  <label htmlFor="">Van</label>
                  <select name='van' value={formik.values.van} onChange={formik.handleChange}>
                    <option value="" disabled selected>-- Select Van --</option>
                    {cars?.map((eachCar, index) => (
                      <option value={eachCar?.id} key={index}>{eachCar?.name}</option>
                    ))}
                  </select>
                  {
                    (formik.touched.van && Boolean(formik.errors.van)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.van && formik.errors.van}</span>
                      :
                      null
                  }
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Incident Date</label>
                    <input
                      type="date"
                      name='incident_date'
                      value={formik.values.incident_date}
                      onChange={formik.handleChange}
                    />
                    {
                      (formik.touched.incident_date && Boolean(formik.errors.incident_date)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.incident_date && formik.errors.incident_date}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={Style["dcmb__cardBody_formArea_feild"]}>
                  <label htmlFor="">Incident Type</label>
                  <select name='incidentType' value={formik.values.incidentType} onChange={formik.handleChange}>
                    <option value="" disabled selected>-- Select Type --</option>
                    <option value="Accident">Accident</option>
                    <option value="Damage">Damage</option>
                    <option value="Theft">Theft</option>
                  </select>
                  {
                    (formik.touched.incidentType && Boolean(formik.errors.incidentType)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.incidentType && formik.errors.incidentType}</span>
                      :
                      null
                  }
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Incident Location</label>
                    <input
                      type="text"
                      name='location'
                      value={formik.values.location}
                      onChange={formik.handleChange}
                      placeholder='Incident Location'
                    />
                    {
                      (formik.touched.location && Boolean(formik.errors.location)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.location && formik.errors.location}</span>
                        :
                        null
                    }
                  </div>
                </div>

               
                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <label htmlFor="">Description</label>
                  <textarea name='description' value={formik.values.description} onChange={formik.handleChange} placeholder='Description...'></textarea>
                  {
                    (formik.touched.description && Boolean(formik.errors.description)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.description && formik.errors.description}</span>
                      :
                      null
                  }
                </div>
            
              
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button type='reset' className={`${Style.dcmb__cancel}`} onClick={onClose}>Discard</button>
          <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
        </div>
      </LeftSidePopupLayout>
    </form>
  )
}

export default VanDamageModal